import React from 'react';
import styled, { keyframes } from 'styled-components';
import { theme } from '../../styles/theme';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerContainer = styled.div<{ $fullScreen?: boolean; $inline?: boolean }>`
  display: ${props => props.$inline ? 'inline-flex' : 'flex'};
  align-items: center;
  justify-content: center;
  padding: ${props => props.$inline ? theme.spacing.xs : theme.spacing.xl};
  ${props => props.$fullScreen && `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    z-index: 9999;
  `}
`;

const Spinner = styled.div<{ $size?: 'small' | 'medium' | 'large' }>`
  width: ${props => {
    switch (props.$size) {
      case 'small': return '20px';
      case 'large': return '60px';
      default: return '40px';
    }
  }};
  height: ${props => {
    switch (props.$size) {
      case 'small': return '20px';
      case 'large': return '60px';
      default: return '40px';
    }
  }};
  border: 3px solid ${theme.colors.borderLight};
  border-top: 3px solid ${theme.colors.primary};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoadingText = styled.p`
  margin-left: ${theme.spacing.md};
  color: ${theme.colors.text.secondary};
  font-size: ${theme.fontSizes.base};
`;

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  fullScreen?: boolean;
  inline?: boolean;
  text?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'medium', 
  fullScreen = false,
  inline = false,
  text 
}) => {
  return (
    <SpinnerContainer $fullScreen={fullScreen} $inline={inline}>
      <Spinner $size={size} />
      {text && !inline && <LoadingText>{text}</LoadingText>}
    </SpinnerContainer>
  );
};